/* eslint-disable indent */
/* eslint-disable react/jsx-indent */
import React from 'react';
import { InfoCard, InfoList } from '../ActiveCustomerDetails.styles';

function SchedaAnagrafica({ activeCustomer }) {
    return (
        <div className="col-12 col-lg-6 active-client-single-page-three">
            <InfoCard>
                <div className="d-flex justify-content-between align-items-center mb-3 pb-3" style={{ borderBottom: '2px solid #f0f0f0' }}>
                    <h4 className="mb-0">Scheda Anagrafica</h4>
                </div>
                <InfoList>
                    {activeCustomer.gender !== 'G' && (
                        <>
                            <li>
                                <strong>Nome:</strong>
                                <span>{activeCustomer.name}</span>
                            </li>
                            <li>
                                <strong>Cognome:</strong>
                                <span>{activeCustomer.surname}</span>
                            </li>
                            <li>
                                <strong>Data di nascita:</strong>
                                <span>{activeCustomer.date_of_birth}</span>
                            </li>
                            <li>
                                <strong>Genere:</strong>
                                <span>{activeCustomer.gender}</span>
                            </li>
                            <li>
                                <strong>Codice Fiscale:</strong>
                                <span>{activeCustomer.fiscal_code}</span>
                            </li>
                        </>
                    )}
                    {activeCustomer.gender === 'G' && (
                        <>
                            <li>
                                <strong>Ragione Sociale:</strong>
                                <span>{activeCustomer.business_name}</span>
                            </li>
                            <li>
                                <strong>Partita Iva:</strong>
                                <span>{activeCustomer.vat_number}</span>
                            </li>
                            <li>
                                <strong>Genere:</strong>
                                <span>{activeCustomer.gender}</span>
                            </li>
                        </>
                    )}
                </InfoList>
            </InfoCard>
        </div>
    );
}

export default SchedaAnagrafica;
